import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'WR' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'WR', label: 'Williams %R', pane: 'sub', params: [6, 10, 14], outputs: ['wr1', 'wr2', 'wr3'], labels: ['Period 1', 'Period 2', 'Period 3'] })
